/* global HTMLAuxUploaderElement */
import { AuxButton, AuxUploader } from "@blk/aladdin-react-components-es";
import { AuxUploaderConstants } from "@blk/aladdin-web-components";
import React, { useRef } from "react";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { getCurrentLocalTime } from "common/date-utils";
export const InsUploadButton = (props) => {
    const ref = useRef(null);
    return React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: "none" } },
            React.createElement(AuxUploader, { accept: props.accept, onChanged: (e) => {
                    props.onChanged(e);
                    ref.current?.clear();
                }, type: "simple", ref: ref })),
        React.createElement(AuxButton, { icon: "upload", label: props.label, size: props.buttonSize, isDisabled: props.isDisabled, type: props.buttonType, className: props.buttonClassName ? props.buttonClassName : "", onClick: props.isDisabled
                ? undefined
                : () => {
                    if (props.appInsightsEventName?.length) {
                        appInsightsTrackEvent({ name: props.appInsightsEventName, properties: { LocalTimestamp: getCurrentLocalTime() } });
                    }
                    const input = ref.current?.shadowRoot?.querySelector(`.${AuxUploaderConstants.CONTAINER_INPUT_SIMPLE}`);
                    if (input) {
                        input.click();
                    }
                } }));
};
